// extracted by mini-css-extract-plugin
export default {"category_card":"Category_category_card__4GrQq","customTooltip":"Category_customTooltip__OqQ9y","toolTipLabel":"Category_toolTipLabel__HN5N+"};